import { useI18n } from '#/i18n/hooks/useI18n';

import {
  FlashBarCloseButton,
  FlashBarCloseButtonHolder,
  FlashBarContainer,
  FlashBarHeadline,
} from './FlashBar.styled';
import type { FlashStyle } from '#/zustand-stores/flashesStore';

type Props = {
  message: string;
  style: FlashStyle;
  onRemove: () => void;
};

export function FlashBar({ message, style, onRemove }: Props) {
  const { i18n } = useI18n();

  const closeHandler = () => {
    onRemove();
  };

  return (
    <FlashBarContainer data-qa-id="flash-message" $variant={style}>
      <FlashBarHeadline>{message}</FlashBarHeadline>
      <FlashBarCloseButtonHolder>
        <FlashBarCloseButton
          type="button"
          qaId="flash-message-close"
          onClick={closeHandler}
          aria-label={i18n('Close alert message')}
          icon={{ name: 'close' }}
          variant={style === 'warn' ? 'tertiary-grey' : 'tertiary-white'}
        />
      </FlashBarCloseButtonHolder>
    </FlashBarContainer>
  );
}
